<!--
Author: TangChen
Date: 2018-02-26
Desc: 购买基金组件，由index.js 配置引入
-->
<template>
    <div class="comp-buy comp">
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item v-if="fund.combinationcode" label="组合代码：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.combinationcode }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="基金代码：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundCode === "515981" ? "515980" : fund.fundCode }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundName }}
                </div>
            </el-form-item>
            <el-form-item v-else label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{'【' + fund.fundname+'+'+ (fund.fundcode === "515981" ? "515980" : fund.fundcode) +'+' }}
                    {{ $cache.getDict('110143',fund.risklevel)+'风险】' }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.comrate" label="投资比例：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.comRate }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.payway" label="支付方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.way">
                    <el-radio v-if="fund.payway.indexOf('1')>-1" label="1" name="sell">
                        现金宝<span>(可用余额：<span
                            class="red"
                        >{{ $util.fmtNum(xjbAll) }}</span>元)</span>
                    </el-radio>
                    <!--暂时屏蔽汇款支付-->
                    <el-radio v-if="fund.payway.indexOf('2')>-1" label="2" name="sell">
                        银行卡&nbsp;
                        <!--<el-tag type="primary">4折</el-tag>-->
                    </el-radio>
                    <el-radio v-if="fund.payway.indexOf('3')>-1" label="3" name="sell">
                        汇款&nbsp;
                        <!-- <el-tag type="primary">低至0折</el-tag> -->
                        <hk-tip v-if="fundInfo.way === '3'"></hk-tip>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="支付渠道：" prop="pay" class="payway-list">
                <el-select
                    v-if="fundInfo.way!=='1' && bankLists.length > 0"
                    v-model="fundInfo.pay"
                    placeholder="请选择支付方式"
                    :class="{'hasVal':bankInfo && bankInfo.label && fundInfo.pay!='' }"
                    v-on:change="bankSel"
                >
                    <el-option-group
                        v-for="(group,index) in bankLists"
                        :key="index"
                        :label="group.label"
                        class="bank-sel"
                    >
                        <el-option
                            v-for="item in group.options"
                            :key="item.moneyaccount"
                            :label="item.label"
                            :value="item.moneyaccount"
                            :disabled="!item.bankAdd&&item.biztype.indexOf('buy') === -1"
                        >
                            <div v-if="!item.bankAdd" class="bank-info">
                                <img :src="$util.getImg(item.bankid)">
                                <span>{{ $util.getDimCard(item.label) }}</span>
                                <span v-if="item.biztype.indexOf('buy') === -1 " style="font-size:13px;color:red">该渠道不支持申购业务</span>
                                <p v-if="!item.bankAdd">
                                    {{ item.text }}
                                </p>
                            </div>
                            <div v-if="item.bankAdd" class="option-group clear">
                                {{ item.bankCate }}<el-button
                                    type="blue"
                                    v-on:click.prevent="$router.push({name:fundInfo.way==='3'?'bank':'addbank'})"
                                >
                                    {{ item.bankAdd }}
                                </el-button>
                            </div>
                        </el-option>
                    </el-option-group>
                </el-select>
                <div v-if="fundInfo.way!=='1' && bankInfo && bankInfo.label" class="el-select-img">
                    <img
                        :src="$util.getImg(bankInfo.bankid)"
                    >
                    <span class="k-text-flow">{{ $util.getDimCard(bankInfo.label) }}</span>
                </div>
                <el-radio-group v-if="(fundInfo.way==='1' && xjbInfo.length===0)||(fundInfo.way!=='1' && bankLists.length === 0)" class="bank-radio">
                    <el-radio label="no-selec" border>
                        <div class="bank-img-sel">
                            <div v-if="fundInfo.way==='1'" class="k-text-flow">
                                您的现金宝还未充值，请立即<span
                                    class="like-a"
                                    v-on:click="$router.push({name:'currencycharge'})"
                                >前往充值</span>
                            </div>
                            <div v-else class="k-text-flow">
                                您的还未添加{{ fundInfo.way==='3'?'汇款':'' }}银行卡，请立即<span
                                    class="like-a"
                                    v-on:click="$router.push({name:fundInfo.way==='3'?'bank':'addbank'})"
                                >前往添加</span>
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
                <el-radio-group
                    v-if="fundInfo.way==='1' && xjbInfo.length>0"
                    v-model="fundInfo.pay"
                    class="bank-radio"
                >
                    <el-radio
                        v-for="bank in xjbInfo"
                        :key="bank.transid+bank.xjbfundcode"
                        :label="bank.transid+bank.xjbfundcode"
                        border
                    >
                        <div class="bank-img-sel">
                            <img :src="$util.getImg(bank.bankid)">
                            <div class="k-text-flow">
                                <span class="bank-name" :title="$cache.getDict('150003',bank.bankid)">{{ $cache.getDict('150003',bank.bankid).toString().substr(0,6) }}</span>总额(元):<span
                                    class="bank-balance"
                                >{{ $util.fmtNum(bank.totalasset) }}</span>
                            </div>
                            <i class="el-icon-check" />
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-show="fund.sharetype === 'A,B'" label="收费方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.sharetype">
                    <el-radio label="A" name="share">
                        前收费
                    </el-radio>
                    <el-radio label="B" name="share">
                        后收费
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="购买金额：" prop="amount" class="redemp-amount" :class="fund.sign&&!isPwdCheck?(!fund.comrate?'':'form-text'):''">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                    prefix-icon="fa fa-jpy"
                />
                <!-- <p v-if="!fund.comrate" class="redemp-prompt">
                    <i class="el-icon-warning" /><span
                        v-if="false"
                        class="red"
                    >购买金额以10的倍数递增，</span><span>{{ fund.fundtype ===
                        '2'?'货币基金零费率':('买入费率' + fund.feerate) }}</span><span v-if="fund.isBuy===''">{{ '，预计'
                        + $util.fmtDate(fund.cfmdate) }}确认份额</span>
                </p> -->
            </el-form-item>
            <el-form-item label=" " class="form-text color-red">
                <div>
                    {{ $util.capitalRMB(fundInfo.amount,"元") }}
                </div>
            </el-form-item>
            <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                <div class="text-con" v-html="feeH" />
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':fund.sign}">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
            </el-form-item>
            <el-form-item style="margin-left:-80px">
                <div v-if="readFileInfoList.length!==0" class="check-box bar-pad showChenckbox" style="font-size: 14px; display: flex; align-items: flex-start;">
                    <div style="display: flex; align-items: flex-start;">
                        <input v-model="checkbox" type="checkbox" style="margin-top:9px" />
                        <span style="padding-left:5px;line-height:30px;width:623px">
                            本人已仔细阅读并同意
                            <span v-for="(item,index) in readFileInfoList" :key="index">
                                <span v-if="$cache.getCompanyInfo().pdf_open_way === '0'">
                                    <a
                                        style="text-decoration:none; color: red"
                                        target="_blank"
                                        v-on:click="getClick(index)"
                                    >《{{ item.textname }}》</a>{{ index === readFileInfoList.length-1? "": index === readFileInfoList.length-2?"和" : "、" }}
                                </span>
                                <span v-else>
                                    <a
                                        :href="item.textaddress"
                                        style="text-decoration:none; color: red"
                                        target="_blank"
                                    >《{{ item.textname }}》</a>{{ index === readFileInfoList.length-1? "": index === readFileInfoList.length-2?"和" : "、" }}
                                </span>
                            </span>
                            等法律文件，确认是本人自主决定购买，符合本人投资目标和风险承受能力。
                        </span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item>
                <div style="width:50%;">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="time>0 || checkBuy == false"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        立即购买
                        <span id="time"></span>
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
            <risk-tip></risk-tip>
            <trade-apply-rule></trade-apply-rule>
        </el-form>
        <pdf-popup base64 :visible="pdfVisible" :need-time="needTime" :read-file-info-list="currentFileInfoList" v-on:close="finishReading"></pdf-popup>
        <img-code :dialog-visible="dialogVisible" v-on:verify-in="getVerifyCode" />
        <fund-protocol v-if="!buySuccess" v-model="protocol" :fund="fund" v-on:all-read="buyFund" />
        <verifycode-check :dialog-visible="checkMobile" :mobile="bankInfo.mobile" v-on:verify-in="checkVerifyCode" />
        <result v-if="buySuccess" :active="2" :result="result" v-on:return-page="reset" v-on:return-login="$router.push({name:'traderecord'})" />
    </div>
</template>
<script>
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import verifycodeCheck from "@/components/form/verifycodeCheck";
import imgCode from "@/components/layout/imgCode.vue";
import hkTip from "@/components/form/hkTip.vue";
import tradeApplyRule from "@/components/form/tradeApplyRule.vue";
import riskTip from "@/components/form/riskTip.vue";
import cache from "@/assets/js/cache";
import PdfPopup from "@/components/util/pdfPopup";
export default {
    name: "Buy",
    components: {
        PdfPopup,
        result,
        fundProtocol,
        verifycodeCheck,
        hkTip,
        riskTip,
        tradeApplyRule,
        imgCode
    },
    data () {
        return {
            // 表单信息
            feeH: "", // 费率信息
            fundInfo: {
                amount: "",
                way: "",
                pay: "",
                sharetype: "",
                pwd: ""
            },
            allBank: [],
            dialogVisible: false,
            btnMsg: "获取短信验证码",
            time: 0, // 验证码再次发送间隔
            isPwdCheck: false, // 是否校验密码
            checkMobile: false, // 短信鉴权验证码显示开关
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您的购买申请已提交成功！",
                btnMsg: "预计11月30日以11月29日净值确认份额，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续购买",
                    event: "return-page"
                },
                btnR: {
                    text: "查看交易记录",
                    event: "return-login"
                },
                transfer: {
                    amount: "",
                    acct_name: "",
                    issuring_bank: "",
                    cnaps: "",
                    acct_no: "",
                    big_cnaps: "",
                    bank_exchange_no: "",
                    payway: ""
                }
            },
            query: null,
            xjbAll: "", // 现金宝总资产
            xjbInfo: [], // 现金宝信息
            fund: {}, // 基金信息获取
            protocol: false,
            bankLists: [], // 银行卡列表
            limit: { text: "起购金额范围为：", min: "0", max: "0" }, // 限额
            rules: {// 校验规则配置
                amount: [
                    { validator: this.amountLimit, trigger: "change" }
                ],
                pay: [
                    { validator: this.validatePayWay, trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            feeGate: {},
            xjbSel: {},
            bankInfo: {}, // 校验银行卡信息
            cfmdate: "", // 确认日期
            checkbox: false, //阅读确认1
            checkTime: true, //阅读确认2
            checkBuy: true,
            readFileInfoList: [],//披露文件信息
            readappno: "", //申请单编号
            infoText: "",
            isReadFileReading: false,
            currentFileInfoList: [],//当前阅读信批文件
            pdfVisible: false,
            needTime: false
        };
    },
    watch: {
        "fundInfo.amount" (val) {
            this.isAmount(val);
        },
        "fundInfo.way" (val) {
            this.fundInfo.pay = "";
            if (val === "1") {
                this.fundInfo.pay = this.xjbInfo[0] ? (this.xjbInfo[0].transid + this.xjbInfo[0].xjbfundcode) : "";
                // this.fundInfo.pay = "";
            } else if (val === "2") {
                this.bankInfo = {};
                this.bankLists = this.allBank.length > 0 ? this.$util.getBankArr(this.allBank) : [];
                this.getBank(val);
                this.fundInfo.pay = "";
            }else if(val === "3"){
                this.bankInfo = {};
                this.bankLists = this.allBank.length > 0 ? this.$util.getBankArr(this.allBank,"1") : [];
                this.getBank(val);
                this.fundInfo.pay = "";

            }
        },
        "fundInfo.sharetype" (val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.pay" (val) {
            if (this.fundInfo.way === "1") {
                const _x = this.xjbInfo.filter(item => {
                    return item.transid + item.xjbfundcode === val;
                })[0];
                if (_x) {
                    this.xjbSel = _x;
                    const _l = Number(_x.totalasset) > Number(this.fund.xjbmax) ? this.fund.xjbmax : _x.totalasset;
                    this.$set(this.limit, "min", this.fund.xjbmin);
                    this.$set(this.limit, "max", _l);
                } else {
                    this.$set(this.limit, "min", "0");
                    this.$set(this.limit, "max", "0");
                }
                this.pla = this.$util.fmtNum(this.limit.min) + "元起，最多可投" + this.$util.fmtNum(this.limit.max) + "元";
                this.queryRate();
            }
        },
        readFileInfoList: {
            handler: function(obj){
                if (obj.every(function (item) {
                    return item.read;//产品概要强制阅读，其他不用
                })) {
                    this.checkbox = true;
                    //this.checkTime = false;
                }
            },
            deep: true
        },
        checkbox(val) {
            if(this.readFileInfoList.length !== 0){
                if (val && !this.isReadFileReading && !this.readFileInfoList[0].read) {
                    this.currentFileInfoList = [this.readFileInfoList[0]];
                    this.needTime = true;
                    this.pdfVisible = true;
                }
                if (!val) {
                    this.readFileInfoList.forEach(item => item.read = false);
                }
            }
        }
    },
    mounted () {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        // 组合购买基金数据初始化
        if (this.fund.comrate) {
            this.initComboData();
        }
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        this.getBuyWay();
        this.getFileInfo();

    },
    methods: {
        getLimit(channelid){
            let channel = channelid === "3" ? "hk" : "bank";
            let min = this.$cache.getChannelLimit(channel,"min") || this.fund.min;//中台配置渠道限额优先取中台配置
            let max = this.$cache.getChannelLimit(channel,"max") || this.fund.max;
            this.$set(this.limit, "min", min);
            this.$set(this.limit, "max", max);
            return this.$util.fmtNum(min) + "元起，最多可投" + this.$util.fmtNum(max) + "元";
        },
        //获取披露文件信息
        getFileInfo(){
            var _this = this;
            this.$util.queryReadFileInfo({"tano": this.fund.tano,"fundcode": this.fund.fundcode,"flag": "0"},res=>{
                res.forEach(item => {
                    item.read = false;
                    if(item.texttype.trim() === "1"){//产品概要
                        _this.readFileInfoList.unshift(item);
                    }else{
                        _this.readFileInfoList.push(item);
                    }
                });
            });
        },
        //获取链接点击事件
        getClick(index){
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading () {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.isReadFileReading = true;
            }
        },
        validatePayWay (rule, value, callback) {
            if (!value) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        // 再次购买重置表单
        reset () {
            this.buySuccess = false;
            this.bankInfo = {};
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "amount", "");
            this.getBuyWay();
        },
        // 处理限额
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        getVerifyCode(val){
            this.dialogVisible = false;
            if (val) {
                this.fundInfo.imgCodeVal = val;
                this.$util.getSdxProtocol(this.fund,(res)=>{
                    this.fund = res;
                    this.protocol = true;
                });
            }
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate () {
            const _this = this;
            let _d = null;
            if (this.fundInfo.amount > 0 && this.fundInfo.sharetype === "A" && ((this.bankInfo.value && this.fundInfo.way !== "1") || (this.xjbSel.xjbfundcode && this.fundInfo.way === "1")) && this.fund.fundtype !== "2") {
                _d = {
                    fundcode: this.fundInfo.way === "1" ? this.xjbSel.xjbfundcode : this.fund.fundcode,
                    amount: this.fundInfo.amount,
                    channelid: this.fundInfo.way === "1" ? this.xjbSel.channelid : this.bankInfo.value,
                    bizcode: this.fundInfo.way === "1" ? "2" : (this.fundInfo.way === "2" ? "1" : "0"),
                    targetfundcode: this.fundInfo.way === "1" ? this.fund.fundcode : ""
                };
                if (this.fund.comrate) {
                    _d.comratelist = this.fund.comrate;
                }
            }
            this.$util.getFee(_d, res => {
                _this.feeGate = res;
                _this.feeH = "<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.charge) + "元</span>(<s>" + _this.$util.fmtNum(_this.feeGate.originfee) + "</s>元，为您节省<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.discount) + "</span>元)";
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            if (this.fundInfo.way == "2" && this.fundInfo.pay && this.fundInfo.amount) {
                let obj = this.allBank.find(item => item.moneyaccount == this.bankInfo.moneyaccount)
                if (obj && obj.minbuysingle && obj.maxbuysingle) {
                    const amount = parseFloat(this.fundInfo.amount);
                    const minAmount = parseFloat(obj.minbuysingle);
                    const maxAmount = parseFloat(obj.maxbuysingle);         
                    // 金额有效性检查
                    if (isNaN(amount)) {
                        this.$message.error("请输入有效的购买金额");
                        return;
                    }  
                    // 金额范围检查
                    if ((amount < minAmount) || (amount > maxAmount)) {
                        this.$alert("当前买入金额超过该卡支付限额，建议使用汇款支付", "", {
                            confirmButtonText: "汇款支付"
                        }).then(() => {
                            this.fundInfo.way = "3";
                        });      
                        return;
                    }                                               
                }
                
            }
            
            if (this.readFileInfoList.length !== 0) {
                if(!this.checkbox){
                    return this.$alert("根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。","提示", {confirmButtonText: "确定"});
                }
            }
            /*if(this.checkTime){
                    let noRead = [];
                    this.readFileInfoList.forEach(res => {
                        if(res.texttype === "1" && res.read === false){
                            noRead.push("《"+res.textname+"》");
                        }
                    })
                    return this.$alert('请点击链接阅读'+noRead,'提示',{confirmButtonText:'确定'})
                }*/
            //获取留痕申请编号
            this.$util.writeFileInfo({
                "readFileInfoList": this.readFileInfoList,
                "fundcode": this.fund.fundcode,
                "tano": this.fund.tano
            }, res=>{ this.readappno = res;});

            this.$children[1].index = 0;
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    if(_this.bankInfo.paytype === "1" && _this.fundInfo.way === "2"){
                        _this.dialogVisible = true;
                    }else{
                        _this.$util.getSdxProtocol(_this.fund,(res)=>{
                            _this.fund = res;
                            _this.protocol = true;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        buyFund(val){
            this.protocol = false;
            if(!val)return;
            if(this.readFileInfoList.length > 0 && this.readappno.length === 0){return this.$alert("没有留痕申请编号,操作失败 请联系客服");}
            const _this = this;
            let _xjbSel = {};
            if (this.fundInfo.way === "1") {
                _xjbSel = this.xjbInfo.filter(item => {
                    return item.transid + item.xjbfundcode === _this.fundInfo.pay;
                })[0];
            }
            // 现金宝不存在，返回
            if (!_xjbSel) {
                return;
            }
            // 默认参数
            let data = {
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                channelid: _this.fundInfo.way === "1" ? "" : _this.bankInfo.value,
                moneyaccount: _this.fundInfo.way === "1" ? _xjbSel.moneyaccount : _this.bankInfo.moneyaccount,
                amount: _this.fundInfo.amount,
                verifycode: this.fundInfo.imgCodeVal,
                tradepwd: _this.$util.enc(_this.fundInfo.pwd),
                readappno: _this.readappno
            };
            // 现金宝购买新增参数
            if (_this.fundInfo.way === "1") {
                data.fundstatus = _this.fund.fundstatus;
                data.targetsharetype = _this.fundInfo.sharetype;
                data.branchcode = _xjbSel.branchcode;
                data.transactionaccountid = _xjbSel.transid;
                data.xjbfundcode = _xjbSel.xjbfundcode;
            }
            let _url = "trade/buy/orderpay";
            // 组合购买基金新增参数
            if (_this.fund.comrate) {
                data.combinationcode = _this.fund.combinationcode || "";
                data.comfundlist = _this.fund.fundcode;
                data.moneyaccount = _this.bankInfo.moneyaccount;
                data.comratelist = _this.fund.comrate;
                data.comtype = "0";
                _url = "trade/buy/orderpay/combine";
            } else { // 普通购买参数添加
                data.targetfundcode = _this.fund.fundcode;
                data.targettano = _this.fund.tano;
                data.targetfundtype = _this.fund.fundtype;
                data.targetfundname = _this.fund.fundname;
                data.payway = _this.fundInfo.way;
                data.sharetype = _this.fundInfo.way === "1" ? _this.xjbInfo[0].sharetype : _this.fundInfo.sharetype;
            }
            if (this.fundInfo.way === "3") {
                this.$util.request("umpf/remittance", {status: "3"}).then(res => {
                    if (res.data) {
                        _this.result.transfer["amount"] = _this.fundInfo.amount;
                        _this.result.transfer["acct_name"] = res.data[0].acct_name.split(/[,，]/)[0];
                        _this.result.transfer["issuring_bank"] = res.data[0].issuring_bank.split(/[,，]/)[0];
                        _this.result.transfer["cnaps"] = res.data[0].cnaps.split(/[,，]/)[0];
                        _this.result.transfer["acct_no"] = res.data[0].acct_no.split(/[,，]/)[0];
                        _this.result.transfer["big_cnaps"] = res.data[0].big_cnaps.split(/[,，]/)[0];
                        _this.result.transfer["bank_exchange_no"] = res.data[0].bank_exchange_no.split(/[,，]/)[0];

                        /*_this.result.transfer = {
                            amount: _this.fundInfo.amount,
                            acct_name: res.data[0].acct_name.split(/[,，]/)[0],
                            bankid: res.data[0].bankid.split(/[,，]/)[0],
                            cnaps: res.data[0].cnaps.split(/[,，]/)[0],
                            acct_no: res.data[0].acct_no.split(/[,，]/)[0],
                            big_cnaps: res.data[0].big_cnaps.split(/[,，]/)[0],
                            bank_exchange_no: res.data[0].bank_exchange_no.split(/[,，]/)[0]
                        };*/
                    }
                });
            }
            this.result.transfer.payway = this.fundInfo.way;
            // 下单
            _this.$util.request(_url, data, "POST").then(res => {
                if (!res.data) {
                    _this.resultMes(res);
                }
                // 获取下单时间
                _this.cfmdate = res.data ? res.data[0].incomecaldate : "";
                // 银行卡支付
                // 组合购买
                if (_this.fund.comrate) {
                    _this.resultMes(res);
                    return;
                }
                // 手机验证
                if (_this.bankInfo.paytype === "1" && _this.fundInfo.way === "2") {
                    _this.checkMobile = true;
                    // 后台支付或现金宝购买
                } else if (_this.bankInfo.paytype === "2" || _this.fundInfo.way !== "2") {
                    _this.resultMes(res);
                    // 页面鉴权支付
                } else if (_this.bankInfo.paytype === "3" && _this.fundInfo.way === "2") {
                    const pageUrl = res.data[0].url;
                    _this.$util.newWinOpen(pageUrl);
                    _this.$util.confirmBankAuth(_this, {}, "trade/buy/payresult", function () {
                        let _x = {
                            msg: res.msg,
                            data: []
                        };
                        _this.resultMes(_x);
                    });
                }
            });
        },
        // 获取对应银行卡信息
        bankSel (val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.moneyaccount === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            this.queryRate();
        },
        // 获取现金宝信息
        getBuyWay () {
            const _this = this;
            const _url = "trade/" + (this.fund.comrate ? "combine" : "buy") + "/buyinfo";
            let _param = { fundcode: this.fund.fundcode };
            if (this.fund.comrate) {
                _param.combinationflag = this.fund.combinationflag ? this.fund.combinationflag : "2"; // 组合申购目前仅支持银行卡购买
                _param.combinationrate = this.fund.comrate;
            }
            this.$util.request(_url, _param).then(res => {
                if (res.data) {
                    _this.fund = Object.assign({}, _this.fund, res.data[0][0]);
                    _this.xjbInfo = res.data[1];
                    let _all = 0;
                    _this.xjbInfo.forEach(item => {
                        _all += Number(item.totalasset);
                    });
                    _this.xjbAll = _all;
                    _this.allBank = res.data[2];
                    _this.$set(this.fundInfo, "way", _this.fund.payway.substr(0, 1));
                    _this.$set(this.fundInfo, "sharetype", _this.fund.sharetype.substr(0, 1));
                }
            });
        },
        // 切换为银行卡支付时数据初始化
        getBank (channelid) {
            // 获取银行卡信息
            const _x = this.bankLists[0] ? this.bankLists[0].options[1].moneyaccount : "";
            if (_x) {
                this.$set(this.fundInfo, "pay", _x);
                this.bankSel(_x);
            }
            this.pla = this.getLimit(channelid);
        },
        // 生成确认信息
        resultMes (res) {
            let code = "1";
            if (res.data) {
                code = (res.data[0].paystatus && res.data[0].paystatus.trim()) || "1";//支付正在处理中返回p
                this.result.cla = "register-success";
                this.result.btnMsg = "预计确认：" + this.$util.fmtDate(this.cfmdate) + "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            /* if (this.fundInfo.way === "3") {
                this.result.transfer = {
                    remitbankbranch: res.data[0].remitbankbranch.split(/[,，]/)[0],
                    remitacctname: res.data[0].remitacctname.split(/[,，]/)[0],
                    remitcardnum: res.data[0].remitcardnum.split(/[,，]/)[0]
                };
            } */
            let state = code === "1" ? "已受理" + (this.result.cla === "register-fail" ? "失败" : "成功") : "正在处理中";
            this.result.msg = "您的" + (this.fundInfo.way === "1" ? "现金宝" : (this.fundInfo.way === "2" ? "" : "汇款")) + "购买申请" + state;
            this.buySuccess = true;
        },
        // 校验用户银行卡手机验证码
        checkVerifyCode (val) {
            this.checkMobile = false;
            if (!val) return false;
            const _this = this;
            this.$util.request("trade/buy/paycheckmsg", { verifycode: val }, "POST").then(res => {
                let _x = {
                    msg: res.msg
                };
                if (res.data) {
                    res.data[0].status = "1";
                    _x.data = [res.data[0]];
                }
                _this.resultMes(_x);
            });
        },
        // 初始化组合定投数据
        initComboData () {
            this.fund.fundCode = "[" + this.fund.fundcode.replace(/,/g, "] [") + "]";
            this.fund.fundName = "[" + this.fund.fundname.replace(/,/g, "] [") + "]";
            const _x = this.fund.comrate.split(",");
            let _y = "";
            for (let i in _x) {
                _y += "[" + _x[i] * 100 + "%] ";
            }
            this.fund.comRate = _y;
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-buy {
    padding-bottom: 30px;
    .pwdForm .el-form-item.form-text {
        margin-bottom: 10px;
    }
    .pwdForm .el-form-item.form-nor {
        margin-bottom: 20px;
    }
    .color-red{
        color: #FF3300;
    }
}
</style>
